export default [
  {
    path: "/login",
    component: () => import("@/views/login/index.vue"),
  },

  {
    path: "/data-screen",
    component: () => import("@/views/data-screen/index.vue"),
  },

  {
    path: "/",
    component: () => import("@/layout/index.vue"),
    children: [
      {
        path: "/index",
        component: () => import("@/views/index/index.vue"),
      },
      {
        path: "",
        component: () => import("@/views/home/index.vue"),
      },
      { /** 修改密码界面 */
        path: "change-password",
        component: () => import("@/views/setting/user/change-password.vue"),
      },
      {
        path: "gis",
        component: () => import("@/views/gis/index.vue"),
      },
      {
        // path: "model",
        path: 'water-model',
        component: () => import("@/views/model/map.vue"),
      },
      {
        path: "manage/task",
        component: () => import("@/views/task/list/index.vue"),
      },
      {
        path: "manage/task-config",
        component: () => import("@/views/task/temp/index.vue"),
      },
      {
        path: "manage/map",
        component: () => import("@/views/task/map/index.vue"),
      },
      {
        path: "manage/task-review",
        component: () => import("@/views/task/list/review.vue"),
      },
      {
        path: "manage/task-remarks",
        component: () => import("@/views/task/remarks/index.vue"),
      },

      {
        path: "assets",
        component: () => import("@/views/assets/index.vue"),
      },

      {
        path: "curing",
        component: () => import("@/views/curing/index.vue"),
      },
      {
        path: "analysis",
        component: () => import("@/views/analysis/index.vue"),
      },
      {
        path: "topic/schedule",
        component: () => import("@/views/topic/schedule/index.vue"),
      },
      {
        path: "detection",
        component: () => import("@/views/topic/detection/index.vue"),
      },
      {
        path: "expert-diagnosis-report",
        component: () => import("@/views/topic/expert-diagnosis-report/index.vue"),
      },
      {
        path: "expert-appraisal",
        component: () => import("@/views/topic/expert-diagnosis-report/appraisal.vue"),
      },
      {
        path: "topic/water-quality",
        component: () => import("@/views/topic/water-quality/index.vue"),
      },
      {
        path: "topic/water-level",
        component: () => import("@/views/topic/water-level/index.vue"),
      },
      {
        path: "topic/maintenance",
        component: () => import("@/views/topic/maintenance/index.vue"),
      },
      {
        path: "test/test",
        component: () => import("@/views/test/test.vue"),
      },

      // 系统设置
      // {
      //   path: "setting",
      //   redirect: "setting/log",
      // },
      {
        path: "pipe-info",
        component: () => import("@/views/pipe-info/index.vue"),
      },
      {
        path: "expand",
        component: () => import("@/views/expand/index.vue"),
      },
      {
        path: "cad1",
        component: () => import("@/views/expand/cad1.vue"),
      },
      {
        path: "detectImg",
        component: () => import("@/views/detectImg/index.vue"),
      },
      {
        path: "setting",
        component: () => import("@/views/setting/index.vue"),
      },
      {
        path: "setting/log",
        component: () => import("@/views/setting/log/index.vue"),
      },
      {
        path: "setting/permission",
        component: () => import("@/views/setting/permission/index.vue"),
      },

      {
        path: "setting/menu",
        component: () => import("@/views/setting/menu/index.vue"),
      },
      {
        path: "setting/menu/add",
        component: () => import("@/views/setting/menu/add.vue"),
      },
      {
        path: "setting/menu/edit",
        component: () => import("@/views/setting/menu/edit.vue"),
      },
      {
        path: "setting/role",
        component: () => import("@/views/setting/role/index.vue"),
      },
      {
        path: "setting/role/add",
        component: () => import("@/views/setting/role/add.vue"),
      },
      {
        path: "setting/role/edit",
        component: () => import("@/views/setting/role/edit.vue"),
      },
      {
        path: "setting/user",
        component: () => import("@/views/setting/user/index.vue"),
      },
      {
        path: "setting/user/add",
        component: () => import("@/views/setting/user/add.vue"),
      },
      {
        path: "setting/user/edit",
        component: () => import("@/views/setting/user/edit.vue"),
      },
      {
        path: "setting/data-dict",
        component: () => import("@/views/setting/data-dict/index.vue"),
      },
      {
        path: "setting/data-dict/add",
        component: () => import("@/views/setting/data-dict/add.vue"),
      },
      {
        path: "setting/data-dict/edit",
        component: () => import("@/views/setting/data-dict/edit.vue"),
      },

      {
        path: "setting/map-label",
        component: () => import("@/views/setting/map-label/index.vue"),
      },

      {
        path: "setting/app-version",
        component: () => import("@/views/setting/app-version/index.vue"),
      },
      {
        path: "setting/app-version/add",
        component: () => import("@/views/setting/app-version/add.vue"),
      },
      {
        path: "setting/app-version/edit",
        component: () => import("@/views/setting/app-version/edit.vue"),
      },

      {
        path: "weather",
        component: () => import("@/views/weather/index.vue"),
      },

      // 企业资产管理
      {
        path: "/property",
        component: () => import("@/views/property/index.vue"),
        children: [
          {
            path: "",
            redirect: "/property/list",
          },
          {
            path: "/property/list",
            component: () => import("@/views/property/list/index.vue"),
          },
          {
            path: "/property/list/add",
            component: () => import("@/views/property/list/add.vue"),
          },
          {
            path: "/property/list/edit",
            component: () => import("@/views/property/list/edit.vue"),
          },


          {
            // 计量资产
            path: "/property/metering",
            component: () => import("@/views/property/metering/index.vue"),
          },
          {
            // 闲置资产
            path: "/property/free",
            component: () => import("@/views/property/free/index.vue"),
          },

          {
            // 价值统计
            path: "/property/analysis",
            component: () => import("@/views/property/analysis/index.vue"),
          },

          // 采购
          {
            path: "/property/buy",
            component: () => import("@/views/property/buy/index.vue"),
          },
          {
            path: "/property/buy/add",
            component: () => import("@/views/property/buy/add.vue"),
          },
          {
            path: "/property/buy/edit",
            component: () => import("@/views/property/buy/edit.vue"),
          },
          {
            path: "/property/buy/detail",
            component: () => import("@/views/property/buy/detail.vue"),
          },
          {
            path: "/property/use",
            component: () => import("@/views/property/use/index.vue"),
          },
          {
            path: "/property/use/add",
            component: () => import("@/views/property/use/add.vue"),
          },
          {
            path: "/property/use/edit",
            component: () => import("@/views/property/use/edit.vue"),
          },
          {
            path: "/property/use/detail",
            component: () => import("@/views/property/use/detail.vue"),
          },

          {
            path: "/property/transfer",
            component: () => import("@/views/property/transfer/index.vue"),
          },
          {
            path: "/property/transfer/add",
            component: () => import("@/views/property/transfer/add.vue"),
          },
          {
            path: "/property/transfer/edit",
            component: () => import("@/views/property/transfer/edit.vue"),
          },
          {
            path: "/property/transfer/detail",
            component: () => import("@/views/property/transfer/detail.vue"),
          },

          {
            path: "/property/check",
            component: () => import("@/views/property/check/index.vue"),
          },
          {
            path: "/property/check/add",
            component: () => import("@/views/property/check/add.vue"),
          },
          {
            path: "/property/check/edit",
            component: () => import("@/views/property/check/edit.vue"),
          },
          {
            path: "/property/check/detail",
            component: () => import("@/views/property/check/detail.vue"),
          },

          {
            path: "/property/scrap",
            component: () => import("@/views/property/scrap/index.vue"),
          },
          {
            path: "/property/scrap/add",
            component: () => import("@/views/property/scrap/add.vue"),
          },
          {
            path: "/property/scrap/edit",
            component: () => import("@/views/property/scrap/edit.vue"),
          },
          {
            path: "/property/scrap/detail",
            component: () => import("@/views/property/scrap/detail.vue"),
          },
        ],
      },
      // 监督管理
      {
        path: "manage/supervise",
        component: () => import("@/views/supervise/index.vue"),
      },
      {
        path: "manage/supervise/detail",
        component: () => import("@/views/supervise/detail.vue"),
      },
      {
        path: "manage/personnel-assess",
        component: () => import("@/views/personnel-assess/index.vue"),
      },
      {
        path: "manage/personnel-assess/add",
        component: () => import("@/views/personnel-assess/add.vue"),
      },
      {
        path: "manage/personnel-assess/edit",
        component: () => import("@/views/personnel-assess/edit.vue"),
      },
      {
        path: "manage/personnel-assess/assess",
        component: () => import("@/views/personnel-assess/assess.vue"),
      },
      {
        path: "manage/log",
        component: () => import("@/views/task/log/index.vue"),
      },



      {
        // 消息中心
        path: "message",
        component: () => import("@/views/message/index.vue"),
      },
      {
        path: "setting/message-config",
        component: () => import("@/views/setting/message-config/index.vue"),
      },

      {
        // 排污企业名册
        path: 'setting/sewage-company',
        component: () => import('@/views/setting/sewage-company/index.vue')
      },

      {
        // 排污监测
        path: 'sewage-monitor',
        component: () => import('@/views/sewage-monitor/index.vue')
      },

      {
        path: "*",
        component: () => import("@/views/404/index.vue"),
      },
    ],
  },
];
